import { render, staticRenderFns } from "./AddNewPackSizePopUp.vue?vue&type=template&id=46348c58&scoped=true&"
import script from "./AddNewPackSizePopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewPackSizePopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewPackSizePopUp.vue?vue&type=style&index=0&id=46348c58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46348c58",
  null
  
)

export default component.exports